import { ChangeDetectorRef, DestroyRef, inject } from '@angular/core';

export abstract class BaseSubscriberChannelComponent {
  protected _destroyRef = inject(DestroyRef);
  protected _cdRef = inject(ChangeDetectorRef);
}
